const product = "https://api2.competiscan.com/product/v1/";
const master = "https://api2.competiscan.com/master/v1/";
const users = "https://api2.competiscan.com/users/v1/";
const vatBackend = "https://api1.competiscan.com/vat-backend/v1/";
const emailaleart = "https://emailaleart.competiscan.com/";
const productDetail =
  "https://api2.competiscan.com/product-detail-fastapi-api/v1/";

module.exports = {
  DEBUG: false,
  login_url: product + "login",
  login_url_prod: users + "login",
  rawData_Url: product + "data/rawdata",
  forgot_password_url: product + "forgotPassword",
  forgot_password__url_prod: users + "forgotPassword",
  reset_forgot_password_url: product + "resetForgotPassword",
  reset_forgot_password__url_prod: users + "resetForgotPassword",
  force_change_password_url: product + "forceChangePassword",
  force_change_password_url_prod: users + "forceChangePassword",
  domain_name: "localhost",
  domain_prod_name: ".competiscan.com",
  // domain_prod_name: "localhost",
  product: product,
  master: master,
  vatBackend: vatBackend,
  emailaleart: emailaleart,
  productDetail: productDetail,
  cscanErateType: master + "cscanErateType",
  cscanDmaCode: master + "cscanDmaCode",
  cscanEdc: master + "cscanEdc",
  IncomeProducing: master + "IncomeProducing",
  ScoreHousehold: master + "ScoreHousehold",
  EtermLength: master + "EtermLength",
  allSectors: master + "master/v1/all-sectors?type=sector",
  raw_additional: master + "raw_additional",
  myexcelcheckbox: master + "myexcelcheckbox",
  CompanyProductname: master + "CompanyProductname",
  filesize: master + "filesize",
  productmuid: master + "productmuid",
  savesearch: emailaleart + "savesearch",
  productdata: productDetail + "data/productdata",
  affinities: productDetail + "data/affinities",
  panelistdetails: productDetail + "data/panelistdetails",
  UpdateQA: productDetail + "updateqa",
  dtsvalues: productDetail + "data/dtsvalue",
  trackingid: productDetail + "data/tracking",
};
